export default "__VITE_ASSET__D4JlFZH7__"